import React from "react"
import LocationCarousel from "../components/locationCarousel"
import MerchantCarousel from "../components/merchantCarousel"
import Layout from "../components/layout"
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"
import InternalLinkingBlock from "../components/internalLinkingBlock"
import ExpandableTextContainer from "@airasia/phoenix-widgets/widgets/ExpandableTextContainer"
import CONTENT_DATA from "../data/phoenix/homepageExpandableTextContainer"
import { Translate } from "../utils/translation"

const MobileContainer = styled.div`
  @media only screen and (min-width: 768px) {
    display: none;
  }
`
const DesktopContainer = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`
const StyledDiv = styled.div`
  margin-top: 1%;

  #pageTitle {
    @media only screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
`
const InternalLinkStyledDiv = styled.div`
  margin-top: 2%;

  #pageTitle {
    @media only screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
`
const IndexPage = props => {
  let locations = props.pageContext.locations.slice(0, 20)
  const type = "country"
  // console.log('Page Context', props.pageContext)
  const location = props.pageContext.countryName
  const url = props.pageContext.url
  const contentData = CONTENT_DATA[url]
  const countryName = props.pageContext.countryName
  const countryCode = props.pageContext.countryCode
  const numberOfCarousels = Math.floor(locations.length / 4);
  const pageTitle = Translate.pageTitle[url]
  const pageText = Translate.pageText[url]
  const InternalLinkingBlockTitle = Translate.InternalLinkingBlockTitle[url]
  const countryTitle= countryName==="Thailand" && url == "/th/th/"?"ประเทศไทย":countryName
  // var ctaExpand = "Read more"
  var expandCtaText = "Read more"
  var compressCtaText = "Read Less"
  var carousels = [];
  var startIndex = 0;
  var desktopBanner = "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food-Delivery-Generic_desktop_new3.png"
  var mobileBanner = "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food-Delivery-Generic_mobile_new2.jpg"
  var bannerURL = url==="/"?"/my/":url
  let lazyLoadImage = true
  for (var i = 0; i < numberOfCarousels; i++) {
    if (i === 0) {
      lazyLoadImage = false
    } else {
      lazyLoadImage = true
    }

    carousels.push(
      <LocationCarousel
        numberOfCarousels={i}
        data={locations.sort().slice(startIndex, startIndex + 4)}
        homepageUrl={url}
        lazyLoadImage={lazyLoadImage}
        enableProgressiveImageLoading={true}
      />
    )
    startIndex += 4
  }

  const internal_linking = {
  Malaysia: {link_objects: [
    {href: "/kuala-lumpur", label: "Food Delivery in Kuala Lumpur"},
    {href: "/george-town", label: "Food Delivery in George Town"},
    {href: "/bayan-lepas", label: "Food Delivery in Bayan Lepas"},
    {href: "/seremban", label: "Food Delivery in Seremban"},
    {href: "/kota-kinabalu", label: "Food Delivery in Kota Kinabalu"}
    ]},
  Singapore: {link_objects: [
    {href: "/pioneer", label: "Food Delivery in Pioneer"},
    {href: "/river-valley", label: "Food Delivery in River Valley"},
    {href: "/novena", label: "Food Delivery in Novena"},
    {href: "/ang-mo-kio", label: "Food Delivery in Ang Mo Kio"},
    {href: "/kallang", label: "Food Delivery in Kallang"}
    ]},
  Thailand: url == "/th/th/"?{link_objects: [
    {href: "/nonthaburi/th/th", label: "อาหารเดลิเวอรี่ในนนทบุรี"},
    {href: "/krung-thep-maha-nakhon/th/th", label: "อาหารเดลิเวอรี่ในกรุงเทพ"},
    {href: "/samutprakan", label: "อาหารเดลิเวอรี่ในสมุทรปราการ"},
    ]}:{link_objects: [
    {href: "/nonthaburi", label: "Food Delivery in Nonthaburi"},
    {href: "/krung-thep-maha-nakhon", label: "Food Delivery in Bangkok"},
    {href: "/samutprakan", label: "Food Delivery in Samut Prakan"},

    ]},
    Indonesia: url == "/id/id/"?{link_objects: [
      {href: "/depok/id/id", label: "Pesan Antar Makanan di Depok"},
      {href: "/bogor/id/id", label: "Pesan Antar Makanan di Bogor"},
      {href: "/banjar/id/id", label: "Pesan Antar Makanan di Banjar"},
      {href: "/south-jakarta/id/id", label: "Pesan Antar Makanan di Jakarta Selatan"},
      {href: "/tangerang/id/id", label: "Pesan Antar Makanan di Tangerang"}
      ]}:{link_objects: [
      {href: "/depok", label: "Food Delivery in Depok"},
      {href: "/bogor", label: "Food Delivery in Bogor"},
      {href: "/banjar", label: "Food Delivery in Banjar"},
      {href: "/south-jakarta", label: "Food Delivery in South Jakarta"},
      {href: "/tangerang", label: "Food Delivery in Tangerang"}
      ]},
  }

  let countryInternalLinking = [
    {description: "", link_objects: [
      {href: "", label: "airasia food in Malaysia"},
      {href: "/th", label: "airasia food in Thailand"},
      {href: "/sg", label: "airasia food in Singapore"},
      {href: "/id", label: "airasia food in Indonesia"},
      ], title: `Not in ${countryName} ? Try airasia food in other countries`},
    ]
  if (url == "/th/th/"){
    countryInternalLinking = [
      {description: "", link_objects: [
        {href: "", label: "แอร์เอเชียฟู๊ดในมาเลเซีย"},
        {href: "/sg", label: "แอร์เอเชียฟู๊ดในสิงคโปร์"},
        {href: "/id", label: "แอร์เอเชียฟู๊ดในอินโดนีเซีย"},
        ], title: `หากคุณไม่ได้อยู่ในประเทศไทย ลองสั่งแอร์เอเชียฟู้ดในประเทศอื่นๆ`},
    ]
    desktopBanner = "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/th-th/Food-Delivery-Generic_desktop_new.jpg"
    mobileBanner = "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/th-th/Food-Delivery-Generic_mobile_new.jpg"
    bannerURL = "/th/th"
    expandCtaText = "อ่านเพิ่มเติม"
    compressCtaText = "ซ่อน"
  }
  if (url == "/id/id/"){
    countryInternalLinking = [
      {description: "", link_objects: [
        {href: "", label: "airasia food di Malaysia"},
        {href: "/th", label: "airasia food di Thailand"},
        {href: "/sg", label: "airasia food di Singapore"},
        ], title: `Tidak di ${countryName}? Coba airasia food di negara lainnya`},
    ]
    bannerURL = "/id/id"
    desktopBanner = "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/id-id/Food-Delivery-Generic_desktop_new.jpg"
    mobileBanner = "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/id-id/Food-Delivery-Generic_mobile_new.jpg"
    expandCtaText = "Selanjutnya"
    compressCtaText = "Tutup"
  }
    
  countryInternalLinking[0].link_objects = countryInternalLinking[0].link_objects.filter(fil => fil.href+"/" !== url)

  return <Layout pageData={{
    heroBanner: [{
      altText: "airasia food",
      bannerID: "FreeDeliveryPromo",
      // buttonText: "Read more",
      buttonUrl: "",
      desktopImage:
      // herobanner.desktop,
      // "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food-Delivery-Generic_desktop_new.jpg",
      desktopBanner,
      headline: "",
      mobileImage:
      // herobanner.mobile,
      // "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food-Delivery-Generic_mobile_new.jpg",
      mobileBanner,
      redirectUrl: url === "/th/th/"||url === "/id/id/"?`https://www.airasia.com/food${bannerURL}`:`https://www.airasia.com/food${bannerURL}en`,
      showButton: false,
      subheadline: "",
      tabletImage: 
      // herobanner.mobile,
      // "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food-Delivery-Generic_mobile_new.jpg",
      mobileBanner,
    }],
  }} location={countryTitle}
      type={type}
      path={url}
      countryCode={countryCode}
      countryUrl={url}
      url={url}>
    <StyledDiv><Title type="h1" customProperties={{id: "pageTitle"}}>{pageTitle+countryTitle}</Title></StyledDiv>
    <StyledDiv><Text>{pageText}</Text></StyledDiv>
    <DesktopContainer>{carousels}</DesktopContainer>
    {url == "/"?
    <>
    <DesktopContainer> <StyledDiv><Title type="h2" customProperties={{id: "pageTitle"}}>Order Food Online from Your Favourite Restaurants</Title></StyledDiv>
    <StyledDiv><Text>airasia food now allows you to order food online from your favourite restaurants the stress-free way. Using the airasia Superapp, order food from popular restaurants like Santan, KFC, Nando’s, A&W, Sushi King, Pizza Hut and Tealive and get them delivered to your doorstep quickly and conveniently.</Text></StyledDiv>
    <MerchantCarousel/></DesktopContainer>
    </>:<></>}
    <MobileContainer><LocationCarousel data={locations.sort()} currentIndex={startIndex} gtmConsumerName={"FOOD - All Cities Page"} homepageUrl={url} /></MobileContainer>
    {url == "/"?<MobileContainer> <StyledDiv><Title type="h2" customProperties={{id: "pageTitle"}}>Order Food Online from Your Favourite Restaurants</Title></StyledDiv>
    <StyledDiv><Text>airasia food now allows you to order food online from your favourite restaurants the stress-free way. Using the airasia Superapp, order food from popular restaurants like Santan, KFC, Nando’s, A&W, Sushi King, Pizza Hut and Tealive and get them delivered to your doorstep quickly and conveniently.</Text></StyledDiv><MerchantCarousel/></MobileContainer>:<></>}
    {/* {internal_linking[countryName] && internal_linking[countryName].map((linking)=>{
      return ( */}
      <InternalLinkStyledDiv>
        <InternalLinkingBlock
            linkObjects={internal_linking[countryName].link_objects}
            blockTitle={InternalLinkingBlockTitle+countryTitle}
            blockDescription=''/>
      </InternalLinkStyledDiv>
      {/* )
    })} */}
      {countryInternalLinking &&
        countryInternalLinking.map(linking => {
          return (
            <InternalLinkStyledDiv>
              <InternalLinkingBlock
                linkObjects={linking.link_objects}
                blockTitle={linking.title}
                blockDescription={linking.description}
              />
            </InternalLinkStyledDiv>
          )
        })}
      {contentData ? (
        <StyledDiv>
          <ExpandableTextContainer
            data={contentData}
            dataSliceLimit={1}
            expandCtaText={expandCtaText ? expandCtaText : "Read more"}
            compressCtaText={compressCtaText ? compressCtaText :"Read Less"}
            ctaColor="secondary"
            ctaHoverColor="neutral"
            ctaHoverUnderlined
            ctaSize="normal"
            ctaUnderlined
            dataProperties={{
              compressCtaText: compressCtaText ? compressCtaText :"Read less",
              ctaColor: "primary",
              ctaHoverColor: "neutral",
              ctaHoverUnderlined: true,
              ctaSize: "small",
              ctaUnderlined: false,
              expandCtaText: expandCtaText ? expandCtaText : "Read more",
              sliceLimit: 350,
              textColor: "neutral",
              textType: "sub",
              titleColor: "neutral",
              titleMarginBottom: "normal",
              titleType: "h3",
            }}
          />
        </StyledDiv>
      ) : (
        <></>
      )}
    </Layout>
  // )

  // return <h1>Entry Page</h1>
}

export default IndexPage
